import React from "react"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Link, StaticQuery, graphql } from "gatsby"
import { Row, Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import MobileFirstImg from "../../images/mobile-first.svg"
import MobileFirstPageStyle from "./mobile-first-page.module.scss"

const MobileFirstSec1 = () => (
    <StaticQuery query={graphql` 
        query MobileFirstSect123 {
            contentfulMobileFirstPage{
                mobileFirstReference{
                  sectionContent1{
                    subtitle{
                      subtitle
                    }
                    sectionParagraph{
                      json
                    }
                  }
                  sectionContent2{
                    subtitle{
                      subtitle
                    }
                    sectionParagraph{
                      json
                    }
                  }
                  sectionContent3{
                    subtitle{
                      subtitle
                    }
                    sectionParagraph{
                      json
                    }
                  }
                }
              }
            }
        `}
    render={data => (

    
    <div className={MobileFirstPageStyle.sectionDiv}>

        {/* Features Links */}
        <Row className={MobileFirstPageStyle.section1Features} id="parent-div">
            <Col xs={12}><h3 className={MobileFirstPageStyle.sectionTitle}>Website Features</h3></Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={MobileFirstPageStyle.featuresBtn1} to="/essentials">The Essentials</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={MobileFirstPageStyle.featuresBtn2} to="/mobile-first">Mobile First</Link>
                </ScrollAnimation>    
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={MobileFirstPageStyle.featuresBtn3} to="/engaging-menu">Engaging Menu</Link>
                </ScrollAnimation>
                </div>
            </Col>
            <Col xs={6}>
                <div id="mobileWebFeatures">
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true} scrollableParentSelector='#parent-div'>
                <Link className={MobileFirstPageStyle.featuresBtn4} to="/convenient-booking">Convenient Booking</Link>
                </ScrollAnimation>
                </div>
            </Col>
        </Row>
        {/* Sections 1 Content */}
        <Row>
            <Col className={MobileFirstPageStyle.mobileFirstSec1Col1} sm={6}>
                <h3 className={MobileFirstPageStyle.sectionTitleLeftAlign}>{data.contentfulMobileFirstPage.mobileFirstReference.sectionContent1.subtitle.subtitle}</h3>
                <div className={MobileFirstPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulMobileFirstPage.mobileFirstReference.sectionContent1.sectionParagraph.json)}
                </div>
            </Col>
            <Col className={MobileFirstPageStyle.mobileFirstSec1Col2} sm={6}>
            <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <MobileFirstImg className={MobileFirstPageStyle.mobileFirstImg} />
                </ScrollAnimation>
            </Col>
        </Row>
        {/* Sections 2 Content */}
        <Row>
            <Col className={MobileFirstPageStyle.mobileFirstSec1Col3} xs={12}>
                <h3 className={MobileFirstPageStyle.sectionTitleLeftAlign}>{data.contentfulMobileFirstPage.mobileFirstReference.sectionContent2.subtitle.subtitle}</h3>
                <div className={MobileFirstPageStyle.sectionDescriptionLeftAlign}>
                  {documentToReactComponents(data.contentfulMobileFirstPage.mobileFirstReference.sectionContent2.sectionParagraph.json)}
                </div>
            </Col>
        {/* Sections 3 Content */}
            <Col className={MobileFirstPageStyle.mobileFirstSec1Col4} xs={12}>
                <h3 className={MobileFirstPageStyle.sectionTitleLeftAlign}>{data.contentfulMobileFirstPage.mobileFirstReference.sectionContent3.subtitle.subtitle}</h3>
                <div className={MobileFirstPageStyle.sectionDescriptionLeftAlign}>
                  {documentToReactComponents(data.contentfulMobileFirstPage.mobileFirstReference.sectionContent3.sectionParagraph.json)}
                </div>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default MobileFirstSec1